<template>
    <div class="content">
        <Row type="flex" align="middle" class="code-row-bg mb16">
            <Col span="20">
                <Breadcrumb>
                    <Breadcrumb-item to="/">首页</Breadcrumb-item>
                    <Breadcrumb-item to="/my/customizedTPL/policy">我的保单</Breadcrumb-item>
                    <Breadcrumb-item>保单详情</Breadcrumb-item>
                </Breadcrumb>
            </Col>
            <Col span="4" class="right">
                <!-- 保障中允许批改 -->
                <Button type="primary" v-if="info.status==2" @click="toRest">批改</Button>
            </Col>
        </Row>
        <!-- 保单信息 -->
        <PolicyBasicInfo class="mb16" :info="info" type="policy"/>
        <!-- 费用信息 -->
        <supportPlans :info="info" type="policy" />
    </div>
    </template>
    <script>
        import PolicyBasicInfo from '../common/PolicyBasicInfo'
        import supportPlans from '../common/supportPlans'
        export default {
            components:{ 
                PolicyBasicInfo,
                supportPlans
            },
            data () {
                return {
                    info:{},
                    id:this.$route.params.id,
                    loading:false,
                }
            },
            mounted () {
                this.getInfo();
            },
            methods:{
                getInfo () {
                    this.$axios.post('/specialEquipment/policy/detail.json',{
                        policyNo: this.id
                    }).then(res=>{
                        this.info=res
                    });
                },
                toRest () {
                    this.$router.push(`/forklift/edit/${this.info.policyNo}`)
                }
            }
        }
    </script>
    <style lang="less" scoped>
        .content{
            width: 100%;
            height: 100%;
            padding: 15px;
            box-sizing: border-box;
        }
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedForklift/policy/detail.vue